import Input from '@/components/@base/input/input';
import Textarea from '@/components/@base/input/textarea';

export { Input, Textarea };
